import React from 'react'
import { cn } from '@/lib/utils'

const STATIC_PATH =
    'M 12.254 10.446 C 11.054 10.105 7.842 8.468 7.624 1.750 C 7.593 0.798 6.852 0.000 5.915 0.000 C 3.983 0.000 2.050 0.000 0.118 0.000 C 0.118 0.000 -1.048 5.514 3.951 8.343 C 6.057 9.536 7.793 9.788 7.793 10.527 C 7.793 11.266 6.057 11.519 3.951 12.711 C -1.048 15.542 0.118 21.055 0.118 21.055 C 2.050 21.055 3.983 21.055 5.915 21.055 C 6.852 21.055 7.593 20.258 7.624 19.305 C 7.842 12.588 11.054 10.951 12.254 10.610 C 12.254 10.555 12.254 10.501 12.254 10.446 Z'

const MORPH_VALUES = [
    STATIC_PATH,
    'M 12.360 10.445 C 11.140 10.098 7.877 8.435 7.656 1.610 C 7.624 0.642 6.871 -0.168 5.919 -0.168 C 3.956 -0.168 1.992 -0.168 0.029 -0.168 C 0.029 -0.168 -1.155 5.434 3.924 8.308 C 6.064 9.520 7.827 9.776 7.827 10.527 C 7.827 11.278 6.064 11.535 3.924 12.746 C -1.155 15.622 0.029 21.223 0.029 21.223 C 1.992 21.223 3.956 21.223 5.919 21.223 C 6.871 21.223 7.624 20.414 7.656 19.445 C 7.877 12.621 11.140 10.958 12.360 10.611 C 12.360 10.555 12.360 10.501 12.360 10.445 Z',
    STATIC_PATH,
    'M 13.245 10.434 C 13.214 7.882 11.903 5.517 9.757 4.137 C 9.214 3.789 8.630 3.511 8.018 3.310 C 6.699 2.877 5.286 2.814 3.933 3.128 C 1.618 3.665 -0.313 5.255 -1.284 7.425 C -1.725 8.412 -1.951 9.482 -1.946 10.563 C -1.941 11.644 -1.705 12.711 -1.254 13.694 C -0.264 15.855 1.682 17.427 4.002 17.943 C 5.358 18.244 6.770 18.168 8.085 17.723 C 8.696 17.516 9.277 17.233 9.816 16.879 C 11.950 15.480 13.238 13.102 13.246 10.551 C 13.246 10.512 13.246 10.473 13.245 10.434 Z',
    'M 12.849 10.439 C 12.820 8.020 11.577 5.778 9.543 4.470 C 9.029 4.140 8.475 3.877 7.894 3.686 C 6.644 3.276 5.305 3.216 4.023 3.514 C 1.828 4.023 -0.002 5.530 -0.922 7.587 C -1.341 8.522 -1.555 9.536 -1.550 10.561 C -1.545 11.586 -1.322 12.598 -0.895 13.529 C 0.045 15.577 1.889 17.067 4.088 17.556 C 5.373 17.842 6.711 17.769 7.958 17.347 C 8.537 17.152 9.088 16.883 9.599 16.548 C 11.621 15.221 12.843 12.968 12.850 10.550 C 12.850 10.513 12.850 10.476 12.849 10.439 Z',
    'M 12.849 10.439 C 12.820 8.020 11.577 5.778 9.543 4.470 C 9.029 4.140 8.475 3.877 7.894 3.686 C 6.644 3.276 5.305 3.216 4.023 3.514 C 1.828 4.023 -0.002 5.530 -0.922 7.587 C -1.341 8.522 -1.555 9.536 -1.550 10.561 C -1.545 11.586 -1.322 12.598 -0.895 13.529 C 0.045 15.577 1.889 17.067 4.088 17.556 C 5.373 17.842 6.711 17.769 7.958 17.347 C 8.537 17.152 9.088 16.883 9.599 16.548 C 11.621 15.221 12.843 12.968 12.850 10.550 C 12.850 10.513 12.850 10.476 12.849 10.439 Z',
    'M 12.525 10.443 C 12.497 8.133 11.311 5.992 9.367 4.743 C 8.877 4.428 8.348 4.176 7.793 3.994 C 6.599 3.602 5.320 3.545 4.096 3.829 C 2.000 4.316 0.252 5.755 -0.626 7.719 C -1.026 8.612 -1.230 9.581 -1.226 10.559 C -1.221 11.538 -1.008 12.504 -0.600 13.394 C 0.297 15.350 2.058 16.773 4.158 17.240 C 5.385 17.512 6.664 17.444 7.854 17.041 C 8.407 16.854 8.933 16.597 9.421 16.277 C 11.353 15.010 12.519 12.858 12.526 10.549 C 12.526 10.513 12.526 10.478 12.525 10.443 Z',
    'M 12.505 10.443 C 11.259 10.089 7.925 8.390 7.699 1.416 C 7.667 0.428 6.898 -0.400 5.925 -0.400 C 3.920 -0.400 1.913 -0.400 -0.092 -0.400 C -0.092 -0.400 -1.303 5.323 3.886 8.260 C 6.072 9.498 7.874 9.760 7.874 10.527 C 7.874 11.294 6.072 11.557 3.886 12.794 C -1.303 15.733 -0.092 21.455 -0.092 21.455 C 1.913 21.455 3.920 21.455 5.925 21.455 C 6.898 21.455 7.667 20.628 7.699 19.639 C 7.925 12.666 11.259 10.967 12.505 10.613 C 12.505 10.556 12.505 10.500 12.505 10.443 Z',
    STATIC_PATH,
    'M 12.360 10.445 C 11.140 10.098 7.877 8.435 7.656 1.610 C 7.624 0.642 6.871 -0.168 5.919 -0.168 C 3.956 -0.168 1.992 -0.168 0.029 -0.168 C 0.029 -0.168 -1.155 5.434 3.924 8.308 C 6.064 9.520 7.827 9.776 7.827 10.527 C 7.827 11.278 6.064 11.535 3.924 12.746 C -1.155 15.622 0.029 21.223 0.029 21.223 C 1.992 21.223 3.956 21.223 5.919 21.223 C 6.871 21.223 7.624 20.414 7.656 19.445 C 7.877 12.621 11.140 10.958 12.360 10.611 C 12.360 10.555 12.360 10.501 12.360 10.445 Z',
    STATIC_PATH,
].join(';')

interface AgentThinkingMarkProps extends React.SVGProps<SVGSVGElement> {
    thinking?: boolean
}

export const AgentThinkingMark: React.FC<AgentThinkingMarkProps> = ({
    thinking = false,
    className,
    ...props
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="-2.67 -0.8475 16.64 22.75"
        role="img"
        aria-label={thinking ? 'Loading' : 'Black Crow mark'}
        className={cn('block h-6 w-auto shrink-0 -ml-[0.18rem]', className)}
        {...props}
    >
        <title>{thinking ? 'Loading' : 'Black Crow mark'}</title>
        {thinking ? (
            <g className="motion-reduce:hidden">
                <g>
                    <path
                        pathLength={100}
                        d={STATIC_PATH}
                        fill="currentColor"
                        fillOpacity={1}
                        stroke="currentColor"
                        strokeWidth={0}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeDasharray="100 0"
                        strokeDashoffset={0}
                    >
                        <animate
                            attributeName="d"
                            calcMode="spline"
                            dur="6.4s"
                            repeatCount="indefinite"
                            values={MORPH_VALUES}
                            keyTimes="0;0.047;0.094;0.161;0.203;0.719;0.796;0.891;0.911;0.956;1"
                            keySplines="0.42 0 0.58 1;0.42 0 0.58 1;.18 .82 .32 1;.30 0 .55 1;0 0 1 1;.45 0 .25 1;.55 0 .15 1;.16 1 .3 1;0.42 0 0.58 1;0.42 0 0.58 1"
                        />
                        <animate
                            attributeName="stroke-dasharray"
                            calcMode="spline"
                            dur="6.4s"
                            repeatCount="indefinite"
                            values="100 0;100 0;26 74;14 86;16 84;36 64;9 91;24 76;15 85;29 71;100 0;100 0"
                            keyTimes="0;0.094;0.203;0.265;0.358;0.399;0.502;0.575;0.667;0.719;0.891;1"
                            keySplines="0 0 1 1;.2 .8 .3 1;.3 0 .7 1;.4 0 .6 1;.15 .85 .35 1;.35 0 .55 1;.3 0 .6 1;.35 0 .6 1;.4 0 .5 1;.45 0 .25 1;0 0 1 1"
                        />
                        <animate
                            attributeName="stroke-dashoffset"
                            calcMode="spline"
                            dur="6.4s"
                            repeatCount="indefinite"
                            values="0;0;-40;-40"
                            keyTimes="0;0.094;0.203;1"
                            keySplines="0 0 1 1;.5 0 .5 1;0 0 1 1"
                        />
                        <animate
                            attributeName="fill-opacity"
                            calcMode="spline"
                            dur="6.4s"
                            repeatCount="indefinite"
                            values="1;1;0;0;1;1"
                            keyTimes="0;0.067;0.117;0.85;0.89;1"
                            keySplines="0 0 1 1;.5 0 .5 1;0 0 1 1;.5 0 .5 1;0 0 1 1"
                        />
                        <animate
                            attributeName="stroke-width"
                            calcMode="spline"
                            dur="6.4s"
                            repeatCount="indefinite"
                            values="0;0;1.45;1.45;0;0"
                            keyTimes="0;0.057;0.106;0.86;0.9;1"
                            keySplines="0 0 1 1;.5 0 .5 1;0 0 1 1;.5 0 .5 1;0 0 1 1"
                        />
                    </path>
                    <animateTransform
                        attributeName="transform"
                        type="rotate"
                        calcMode="spline"
                        dur="6.4s"
                        repeatCount="indefinite"
                        values="0 5.65 10.5275;0 5.65 10.5275;260 5.65 10.5275;340 5.65 10.5275;620 5.65 10.5275;720 5.65 10.5275;720 5.65 10.5275"
                        keyTimes="0;0.203;0.358;0.487;0.616;0.719;1"
                        keySplines="0 0 1 1;.45 0 .55 1;.65 0 .35 1;.35 0 .65 1;.45 0 .35 1;0 0 1 1"
                    />
                </g>
            </g>
        ) : null}
        <path
            d={STATIC_PATH}
            fill="currentColor"
            className={thinking ? 'hidden motion-reduce:inline' : undefined}
        />
    </svg>
)
